<template>
  <div class="breadcrumb-wrap">
    <div class="pre-wrap">
      <a-icon type="environment" />
    </div>
    <a-breadcrumb separator="/">
      <a-breadcrumb-item
        v-for="(item, index) in options"
        :key="item.name"
      >
        <span
          @click="toPath(item, index)"
          class="crumbItem"
        >{{
          item.name
        }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    options: Array
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    toPath(instance, index) {
      const preList = this.options.slice(0, index)
      let toRouter = ''
      if (preList.length > 0) {
        preList.forEach(item => {
          toRouter += `/${item.toRouter}` // 获取前面路由
        })
      }
      toRouter += `/${instance.toRouter}` // 组合当前点击
      const currentRouter = this.$route.path
      if (currentRouter === toRouter) return // 如果点击当前路由直接退出
      let selectedId = this.$route.query.selectedId
      //对应面包屑跳转上一级的路由
      console.log(toRouter, 'toRouter')
      let arr = [
        { toRouter: '/index', name: 'index', query: {} },
        {
          toRouter: '/informationService/wkt',
          name: 'informationService',
          query: { selectedId, code: 'wkt' }
        },
        {
          toRouter: '/informationService/syxly',
          name: 'informationService',
          query: { selectedId, code: 'syxly' }
        },
        {
          toRouter: '/informationService/cxsl',
          name: 'informationService',
          query: { selectedId, code: 'cxsl' }
        },
        {
          toRouter: '/informationService/kcjx',
          name: 'informationService',
          query: { selectedId, code: 'kcjx' }
        },
        {
          toRouter: '/informationService/zsjs',
          name: 'informationService',
          query: { selectedId, code: 'zsjs' }
        },
        {
          toRouter: '/resourceNavigation/fxbg',
          name: 'resourceNavigation',
          query: { selectedId, code: 'fxbg' }
        },
        {
          toRouter: '/resourceNavigation/fwal',
          name: 'resourceNavigation',
          query: { selectedId, code: 'fwal' }
        },
        {
          toRouter: '/resourceNavigation/ywyj',
          name: 'resourceNavigation',
          query: { selectedId, code: 'ywyj' }
        },
        {
          toRouter: '/informationCenter/xwdt',
          name: 'informationCenter',
          query: { selectedId, code: 'xwdt' }
        },
        {
          toRouter: '/informationCenter/tzgg',
          name: 'informationCenter',
          query: { selectedId, code: 'tzgg' }
        },
        {
          toRouter: '/informationCenter/jjzy',
          name: 'informationCenter',
          query: { selectedId, code: 'jjzy' }
        },
        {
          toRouter: '/informationCenter/zxgz',
          name: 'informationCenter',
          query: { selectedId, code: 'zxgz' }
        }
      ]

      arr.forEach(item => {
        console.log(item, 'item')
        if (toRouter === item.toRouter) {
          this.$router.push(item)
        }
      })
    }
  }
}
</script>
